import Schedule from '../components/schedule/Schedule';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/schedule',
  component: Template,
  children: [
    {
      path: '',
      name: 'Schedule',
      component: Schedule,
      meta: {
        title: 'Schedule - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/scheduleRoutes.js